module.exports = "/components/components/whatsNewComponent-af8e8e.html";